{ type Table } from dexie

{ Bindable } from ../bindable.civet

FolderEntry := (path: string, prefix: string) ->
  folder: true
  path: prefix + path
  relativePath: path

declare var Dexie: typeof import("dexie").Dexie

// DexieDB Containing our FS
DexieFSDB := (dbName='fs') ->
  db := new Dexie dbName

  db.version(1).stores
    files: 'path, blob, size, type, createdAt, updatedAt'

  return db

// FS Wrapper to Dexie database
export class DexieFS with Bindable
  Files: Table

  @(dbName='fs')
    super()

    db := DexieFSDB(dbName)

    // @ts-ignore
    @Files = db.files

  notify(eventType: string, path: string)
    <T>(result: T) =>
      @trigger eventType, path
      return result

  // Read a blob from a path
  read(path: string)
    @Files.get(path)
    .then (result) =>
      result?.blob
    .then @notify "read", path

  // Write a blob to a path
  write(path: string, blob: Blob)
    throw new Error "Can only write blobs to the file system" unless blob instanceof Blob
    now := +new Date

    @Files.put
      path: path
      blob: blob
      size: blob.size
      type: blob.type
      createdAt: now
      updatedAt: now
    .then @notify "write", path

  // Delete a file at a path
  delete(path: string)
    @Files.delete(path)
    .then @notify "delete", path

  // List files and folders in a directory
  list(dir: string)
    files .= await @Files.where("path").startsWith(dir).toArray()

    folderPaths: Record<string, true> := {}

    files = files.filter (file) ->
      file.relativePath = file.path.replace(dir, "")

      if file.relativePath.match /\// // folder
        folderPath := file.relativePath.replace /\/.*$/, "/"
        folderPaths[folderPath] = true
        return
      else
        return file

    folders := Object.keys(folderPaths).map (folderPath) ->
      FolderEntry folderPath, dir

    return folders.concat(files)
